export default "__VITE_ASSET__66556c88__"